import api from '@src/services/api';
import { toastError } from '@src/utility/Toast';
import axios from 'axios';

const getIpV4 = async () => {
  try {
    const response = await axios.get('https://api.ipify.org?format=json', {
      timeout: 40000, // 40 segundos
    });
    const { ip } = response.data;
    return ip;
  } catch (error) {
    // toastError({
    //   title: 'Ops! Algo deu errado',
    //   description: 'em pegar o IPv4',
    // });
  }
};

export default getIpV4;
